import type { ReactElement } from 'react'

import type { CaseItemStatus } from 'Portal/__generated__/globalTypes'

export interface PreviewColumnProps {
  id: string
  url?: string
  type: PreviewColumnTypeEnum
  headerElement?: ReactElement
  contentElement?: ReactElement
  isLoading?: boolean
  onClosePreviewColumn: () => void
  disableFooterAskQuestion?: boolean
  renderCustomFooterButton?: ReactElement
  hideFooter?: boolean
  isVisible: boolean
}

export interface PreviewColumnHeaderProps {
  name: string
  title?: string
  badge?: ReactElement | null
  image?: string | null
  isReturnBlocked?: boolean
  productType?: string | null
  caseItemStatus?: CaseItemStatus
  returnCasePortalStatus?: string
  onClosePreviewColumn: () => void
  renderPreviewColumnHeaderSub?: ReactElement
}

export interface PreviewColumnContentProps {
  content: PreviewColumnCellProps[]
  twoColumn?: boolean
  children?: React.ReactNode
}

export interface PreviewColumnCellProps {
  label: string
  value?: string | React.ReactElement | null
  copyable?: boolean
  disableLabelTranslation?: boolean
}

export interface PreviewColumnFooterProps {
  id: string
  url?: string
  type: PreviewColumnTypeEnum
  onClosePreviewColumn: () => void
  renderCustomFooterButton?: ReactElement
  disableAskQuestion?: boolean
}

export enum PreviewColumnTypeEnum {
  Rental = 'rental',
  Employee = 'employee',
  PhonePlan = 'phone plan',
  Request = 'request',
  Bundle = 'bundle',
  Return = 'return',
}

export const PREVIEW_COLUMN_TYPE_TRANSLATION_IDS: Record<
  PreviewColumnTypeEnum,
  string
> = {
  [PreviewColumnTypeEnum.Rental]: 'PreviewColumn_type_rental',
  [PreviewColumnTypeEnum.Employee]: 'PreviewColumn_type_employee',
  [PreviewColumnTypeEnum.PhonePlan]: 'PreviewColumn_type_phone_plan',
  [PreviewColumnTypeEnum.Request]: 'PreviewColumn_type_request',
  [PreviewColumnTypeEnum.Bundle]: 'PreviewColumn_type_bundle',
  [PreviewColumnTypeEnum.Return]: 'PreviewColumn_type_return',
}
